import { ALLOCATION_SKILLS } from "@/constants/allocations";

export type AllocationSkillId = keyof typeof ALLOCATION_SKILLS;

export type AllocationSkills = {
  [K in AllocationSkillId]?: number;
};

export interface WorkerAllocation {
  userId: number;
  name: string;
  departmentId: string;
  department: string;
  shiftStart: string;
  shiftEnd: string;
  allocationSkills: AllocationSkills;
  receivingLeads: boolean;
}

export interface AllocationsUploadResponse {
  success: boolean;
  message?: string;
  errors?: string[];
  processedCount?: number;
  failedCount?: number;
}

export interface AllocationsFilter {
  department: string;
  search: string;
}

export interface AllocationSkillResponse {
  userId: number;
  receivingLeads: boolean;
  shiftStart: string | null;
  shiftEnd: string | null;
  allocationSkills: {
    [skillId: string]: number;
  };
}

export interface ShiftCapsPayload {
  userId: number;
  shiftStart: string | null;
  shiftEnd: string | null;
  allocationSkills: {
    [skillId: string]: number;
  };
}

export interface ValidationErrorResponse {
  [key: string]: string;
}

export interface ValidationError {
  type: "validation";
  errors: ValidationErrorResponse;
}

export const isValidationError = (err: unknown): err is ValidationError =>
  typeof err === "object" && err !== null && "type" in err && (err as ValidationError).type === "validation";

export interface ShiftCapsSubmitResponse {
  message: string;
}

export interface AvailableSkill {
  allocationSkillId: number;
  allocationSkillTypeId: number;
  name: string;
  value: string;
}

export interface UserSkillAssignment {
  intranetUserId: number;
  allocationSkillId: number;
  isPrimary: boolean;
  allocationSkillTypeId: number;
  numberOfAllocations: number;
  cap: number | null;
}

export interface UpdateUserSkillsPayload {
  userId: number;
  primarySkillIds: number[];
  secondarySkillIds: number[];
  originalTarget: number;
  newTarget: number;
}

export interface CapFilter {
  skillId: AllocationSkillId;
  min?: number;
  max?: number;
}
